import { render } from "./Settlement.vue?vue&type=template&id=ff9573b6"
import script from "./Settlement.vue?vue&type=script&lang=js"
export * from "./Settlement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__